import { setupWorker, type SetupWorker } from "msw/browser";
import { getHandlers } from "./handlers";
import { getMockMode } from "@/config/apiClient.config";

class MSWSingleton {
  private worker: SetupWorker;
  private isStarted = false;
  private restarting: Promise<void> | null = null;

  constructor() {
    this.worker = setupWorker(...getHandlers(getMockMode()));
  }

  async start() {
    if (!this.isStarted) {
      await this.worker.start({
        onUnhandledRequest: "bypass",
      });

      setInterval(() => fetch("/ping"), 30000);

      this.isStarted = true;
      console.info("[MSW] started");
    }
  }

  close() {
    // no-op in browser simplifies type checking
  }

  get instance() {
    return this.worker;
  }
}

let instance: MSWSingleton | null = null;

export function getMSW(): MSWSingleton {
  if (!instance) {
    instance = new MSWSingleton();
  }
  return instance;
}
